<ng-content select=".row-cell-view-left"></ng-content>
<ng-content select=".row-cell-view-middle"></ng-content>
<ng-content select=".row-cell-view-right"></ng-content>
